import { render } from "./Timer.vue?vue&type=template&id=66480c02&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"

import "./Timer.vue?vue&type=style&index=0&id=66480c02&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66480c02"]])

export default __exports__